export function getAutocompleteLabel(option, labelField = "title") {
  if (typeof option === "string") {
    return option;
  }

  if (!option || typeof option !== "object") {
    return "";
  }

  if (typeof option.inputValue === "string" && option.inputValue !== "") {
    return option.inputValue;
  }

  const label = labelField === "nombre" && option.etiqueta ? option.etiqueta : option[labelField];
  return typeof label === "string" ? label : "";
}

// The forms use empty objects internally; Material-UI expects null for no selection.
export function normalizeAutocompleteValue(value, labelField = "title") {
  return getAutocompleteLabel(value, labelField) === "" ? null : value;
}
